import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "nameTypeSelect",
    "singleNameInputGroup",
    "singleNameInput",
    "detailedNameInputGroup",
    "givenNameInput",
    "familyNameInput"
  ]

  static values = {
    isPersonal: { type: String, default: "Personal" }
  }

  connect() {
    if (!this.hasNameTypeSelectTarget) return

    this.nameTypeSelectTarget.addEventListener("change", function() {
      this.toggleNameInputs(true)
    }.bind(this))

    this.toggleNameInputs(false)
  }

  disconnect() {
    if (!this.hasNameTypeSelectTarget) return

    this.nameTypeSelectTarget.removeEventListener("change", this.toggleNameInputs)
  }

  toggleNameInputs(clearInputs = false) {
    const isPersonal = this.nameTypeSelectTarget.value === this.isPersonalValue

    if (clearInputs) {
      this.givenNameInputTarget.value = ""
      this.familyNameInputTarget.value = ""
      this.singleNameInputTarget.value = ""
    }

    if (this.hasSingleNameInputGroupTarget) {
      this.singleNameInputGroupTarget.style.display = isPersonal ? "none" : "block"
    }

    if (this.hasDetailedNameInputGroupTarget) {
      this.detailedNameInputGroupTarget.style.display = isPersonal ? "block" : "none"
    }
  }
}
